document.addEventListener("DOMContentLoaded", () => {
  const paymentPlans = {
    credit: {
      amex: [
        { installments: 1, interest: 0 },
        { installments: 3, interest: 0 },
        { installments: 6, interest: 0 },
      ],
      visa: [
        { installments: 1, interest: 0 },
        { installments: 3, interest: 0 },
        { installments: 6, interest: 0 },
      ],
      mastercard: [
        { installments: 1, interest: 0 },
        { installments: 3, interest: 0 },
        { installments: 6, interest: 0 },
      ],
      naranja: [{ installments: 1, interest: 0 }],
    },
    debit: {
      visa: [{ installments: 1, interest: 0 }],
      mastercard: [{ installments: 1, interest: 0 }],
    },
  };

  const getMaxInstallments = (price, three, six) => {
    if (price >= six) return 6;
    if (price >= three) return 3;
    return 1;
  };

  const updateLabel = (container, price, three, six) => {
    if (!container || !price) return;
    const max = getMaxInstallments(price, three, six);
    const perInstallment = price / max;

    container.textContent =
      max > 1
        ? `${max} cuotas sin interés de ${perInstallment.toLocaleString("es-AR", { style: "currency", currency: "ARS" })}`
        : `1 cuota sin interés de ${price.toLocaleString("es-AR", { style: "currency", currency: "ARS" })}`;
  };

  const labelContainers = document.querySelectorAll(".price-installments-label");

  labelContainers.forEach((label) => {
    const price = parseFloat(label.dataset.price || 0);
    const three = parseFloat(label.dataset.three || 0);
    const six = parseFloat(label.dataset.six || 0);

    updateLabel(label, price, three, six);
  });

  const productGrid = document.querySelector(".filters-adjacent");

  if(productGrid) {
    const productGridObs = new MutationObserver(() => {
      productGridObs.disconnect();
      const labels = document.querySelectorAll(".price-installments-label");

      labels.forEach((label) => {
        const price = parseFloat(label.dataset.price || 0);
        const three = parseFloat(label.dataset.three || 0);
        const six = parseFloat(label.dataset.six || 0);
        updateLabel(label, price, three, six);
      });

      productGridObs.observe(productGrid, { childList: true, subtree: true });
    });

    productGridObs.observe(productGrid, { childList: true, subtree: true });
  }

  const modal = document.getElementById("product-paying-methods-modal");
  if (!modal) return;

  const detailsContainer = modal.querySelector("#payment-details");
  const openBtn = document.getElementById("open-modal-btn");
  const closeBtn = document.getElementById("close-modal-btn");
  const overlay = modal.querySelector(".modal-overlay");
  const typeButtons = modal.querySelectorAll(".payment-type-btn");
  const methodButtons = modal.querySelectorAll(".payment-btn");

  let currentType = "credit";
  let currentMethod = "amex";

  const price = parseFloat(modal.dataset.price || 0);
  const three = parseFloat(modal.dataset.three || 0);
  const six = parseFloat(modal.dataset.six || 0);

  const renderTable = (type, method) => {
    if (!detailsContainer || !paymentPlans[type] || !paymentPlans[type][method]) return;

    const maxInstallments = getMaxInstallments(price, three, six);
    let plans = paymentPlans[type][method];

    if (type === "credit") plans = plans.filter((p) => p.installments <= maxInstallments);

    const rows = plans
      .map((plan) => {
        const total = price * (1 + plan.interest);
        const perInstallment = total / plan.installments;
        return `
          <tr>
            <td>${plan.installments} cuota${plan.installments > 1 ? "s" : ""} de ${perInstallment.toLocaleString("es-AR", { style: "currency", currency: "ARS" })}</td>
            <td>${plan.interest > 0 ? (plan.interest * 100).toFixed(0) + "%" : "Sin interés"}</td>
            <td>${total.toLocaleString("es-AR", { style: "currency", currency: "ARS" })}</td>
          </tr>`;
      })
      .join("");

    detailsContainer.innerHTML = `<table class="payment-table"><thead><tr><th>Cuotas</th><th>Interés</th><th>Valor Total</th></tr></thead><tbody>${rows}</tbody></table>`;
  };

  const updateVisibleMethods = (type) => {
    methodButtons.forEach((btn) => {
      const types = btn.dataset.types.split(",");
      btn.style.display = types.includes(type) ? "inline-flex" : "none";
    });

    const firstAvailable = Array.from(methodButtons).find((b) => b.style.display !== "none");
    if (firstAvailable) {
      methodButtons.forEach((b) => b.classList.remove("active"));
      firstAvailable.classList.add("active");
      currentMethod = firstAvailable.dataset.method;
    }
  };

  openBtn?.addEventListener("click", () => modal.setAttribute("aria-hidden", "false"));
  closeBtn?.addEventListener("click", () => modal.setAttribute("aria-hidden", "true"));
  overlay?.addEventListener("click", () => modal.setAttribute("aria-hidden", "true"));

  typeButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      typeButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      currentType = btn.dataset.type;
      updateVisibleMethods(currentType);
      renderTable(currentType, currentMethod);
    });
  });

  methodButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      methodButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      currentMethod = btn.dataset.method;
      renderTable(currentType, currentMethod);
    });
  });

  updateVisibleMethods(currentType);
  renderTable(currentType, currentMethod);
});
